const custAuth = {
    path: 'custReport',
    name: 'custReport',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'report',
        icon: 'HSIconfont hs-icon-report',
        showRealm: ['SYSTEM', 'ADMIN']
    },
    children: [
        {
            path: 'custReportConfig',
            name: 'custReportConfig',
            component: () => import('@/views/custReportConfig'),
            meta: { code: 'report:config' }

        }
    ]
};

export default custAuth;
